import { defaultTheme } from '@xstyled/styled-components'
import breakpoints from './breakpoints'
import colors from './colors'
import shadows from './shadows'
import typography from './typography'

export const core = {
  colors: colors,
  fonts: {
    ...defaultTheme.fonts,
    ...typography.fonts
  },
  fontSizes: {
    ...defaultTheme.fontSizes,
    ...typography.fontSizes
  },
  lineHeights: {
    ...defaultTheme.lineHeights,
    ...typography.lineHeights
  },
  texts: {
    ...defaultTheme.texts,
    ...typography.texts
  },
  screens: {
    ...defaultTheme.screens,
    ...breakpoints
  },
  shadows: {
    ...defaultTheme.shadows,
    ...shadows
  }
}
